export const api_url = "https://bk.va.nycu.edu.tw:789";
//export const api_url = "https://localhost:7179";
//export const api_url = "https://140.113.27.142:789";

const getFromLocalStorage = (key, defaultValue) => {
    const storedValue = localStorage.getItem(key);
    try {
        return storedValue !== null ? JSON.parse(storedValue) : defaultValue;
    } catch (e) {
        console.warn(`Error parsing JSON from localStorage for key "${key}":`, e);
        return storedValue;
    }
};

// Export login information by getting it from localStorage
export const loginInfo = {
    login_local_unit_name: getFromLocalStorage("login_local_unit_name", ""),
    login_state: getFromLocalStorage("login_state", false),
    login_time: getFromLocalStorage("login_time", ""),
    login_user_id: getFromLocalStorage("login_user_id", ""),
    login_user_name: getFromLocalStorage("login_user_name", ""),
    login_user_net_id: getFromLocalStorage("login_user_net_id", ""),
    login_user_net_name: getFromLocalStorage("login_user_net_name", ""),
    login_user_type: getFromLocalStorage("login_user_type", ""),
    login_user_unit_id: getFromLocalStorage("login_user_unit_id", ""),
    registrationStatus: getFromLocalStorage("registrationStatus", 0),
    tenable_page: getFromLocalStorage("tenable_page", false)
};